<template>
  <div class="detail">
    <div>
      <van-nav-bar
        @click-left="onClickLeft"
        fixed
        placeholder
        :title="$t('nav.noticeDetail')"
      >
        <template #left>
          <van-icon color="#000" name="arrow-left" />
        </template>
      </van-nav-bar>
    </div>

    <div class="content-section" style="margin-top: 10px">
      <div class="content-title">{{ notice.noticeTitle }}</div>
      <div class="content-time">{{ notice.createTime }}</div>
      <div class="content-detail" v-html="notice.noticeContent"></div>
    </div>

    <!-- 
     Dear members:
        <br/>
        1. The platform supports USDT, RMB, Hong Kong dollars, US dollars, Japanese yen, new
        Coin... Store value channel, use USDT to store value and you can get an exclusive gift of 3% of the principal.
        Gift money!
        <br/>
        2. The deposit and withdrawal stored value cards on the platform are approved by the China Banking Regulatory Commission. bank card
        It is changed from time to time. To store value, please be sure to contact the online customer service of the bank to obtain the latest bank information.
        card number.
        <br/>
        3. Please verify your bank card name, card number, and bank information in a blink of an eye. It will be completed in a blink of an eye.
        The single truncation circle of the running water will be verified and sealed by Faxing’s online customer service.
        <br/>
        4. The bank card number will be changed according to the time issued by the online customer service. If it times out,
        Please contact Traditional Online Customer Service again to obtain the card number.
        <br/>
        5. In order to avoid unnecessary losses, be sure to comply with the above stored value precautions.
        Matters, this platform will not be responsible for any unauthorized recharging without contacting the traditional online customer service.
        <br/>
        Thanks for your cooperation
        <br/>
        Sincerely, Macau Grand Lisboa~    
    -->

    <!-- <div v-else class="content-section" style="margin-top: 10px">
      <div class="content-title">Platform announcement</div>
      <div class="content-time">2020-03-18 04:22:31</div>
      <div class="content-detail">
        Dear member: The receiving bank account number of this platform may change at any time, please be sure to contact the online customer service to obtain the real-time receiving account number before recharging every time! If you transfer to the wrong account due to your mistake, this site has the right not to award points for your transfer! Please understand and support, I wish you a happy life and a lot of winning! !
      </div>
    </div> -->
  </div>
</template>

<script>
import { getNoticeDetail } from "@/common/api/api";

export default {
  name: "detail",
  data() {
    return {
      url: "",
      show: false,
      n: "",
      notice: {},
    };
  },
  created() {
    const m = this.$route.params && this.$route.params.m;
    this.n = this.$route.params && this.$route.params.n;
    this.url = "/announcement/" + m;
    this.getNoticeDetail(this.n)
  },
  methods: {
    onClickLeft() {
      this.$router.push(this.url);
    },
    getNoticeDetail(noticeId) {
      getNoticeDetail(noticeId).then((res) => {
        this.notice = res.data;
      });
    },
  },
};
</script>

<style>
.content-section {
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 10px;
  margin: 0 10px 10px 10px;
}

.content-title {
  font-size: 20px;
  font-weight: 600;
}

.content-time {
  color: #a7a5a5;
  padding: 10px;
  text-align: left;
  font-size: 14px;
}

.content-detail {
  text-align: left;
  font-family: "Times New Roman", Times, serif;
  letter-spacing: 2px;
}
</style>
